import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-book-open-line text-white text-lg"></i>
              </div>
              <span className="text-lg font-bold text-foreground-900">
                {t('site.name')}
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('site.tagline')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/rexiao" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  {t('footer.categories')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  {t('footer.about')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              {t('footer.support')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  {t('footer.contact')}
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  {t('footer.feedback')}
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  {t('footer.help')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              {t('footer.follow')}
            </h4>
            <div className="flex gap-3 mb-4">
              <a href="#" className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-white transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-white transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-white transition-all duration-200" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
            <div className="flex flex-wrap gap-2">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">{t('footer.privacy')}</a>
              <span className="text-foreground-400">·</span>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">{t('footer.terms')}</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">{t('footer.copyright')}</p>
          <p className="text-xs text-foreground-400">
            本站所有漫画均来自网络，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}